import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  copy(event) {
    const text = event.currentTarget.dataset.text;
    navigator.clipboard.writeText(text).then(() => {
      // ── FlashToastController を取得して show を呼ぶ ──
      const toast = this.application.getControllerForElementAndIdentifier(
        document.getElementById("flash"),
        "flash-toast",
      );
      toast.show("URLをコピーしました。");
    });
  }
}
